module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Рекомендуемые суммы","track":"Suggested amounts"}}